<script>
import {email, helpers, required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import AppBaseView from "@/mobile/AppBaseView.vue";
import {mapActions} from "pinia";
import {authStore} from "@/store/authStore";

export default {
  name: "ForgotPasswordView",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    AppBaseView
  },
  data() {
    return {
      yourEmail: '',
      sendPasswordError: null,
      emailNotExistError: false,
      isEmailSent: false,
      buttonState: true
    }
  },
  validations () {
    return {
      yourEmail: {
        required: helpers.withMessage('validations.required', required),
        email: helpers.withMessage('validations.email', email),
        successful: helpers.withMessage('validations.resetPasswordError', () => this.sendPasswordError === null),
        emailNotExist: helpers.withMessage('auth.sendPassword.noAccountFound', () => this.emailNotExistError === false),
      },
    }
  },
  methods: {
    ...mapActions(authStore, [
      'sendPasswordAction'
    ]),
    async sendEmail() {
      const isFormCorrect = await this.v$.$validate()

      if (isFormCorrect) {
        this.sendPasswordAction(this.yourEmail).then(()=> {
          this.isEmailSent = true;
          this.buttonState = false;
          setTimeout( ()=> {
            this.$router.go(-1);
          }, 3000);
        }).catch(error => {
          const errorCode = error.response.status;

          if (errorCode === 404) {
            this.emailNotExistError = true;
            this.disableSubmitBtn = true;
          } else {
            this.sendPasswordError = error;
          }
        })
      }

    }
  }
}
</script>

<template>
<app-base-view>
  <div class="forgot-password-view">
    <h3 class="forgot-password-view__title">
      {{$t('auth.forgotPassword.restorePassword')}}
    </h3>
    <span class="forgot-password-view__desc">
      {{$t('auth.forgotPassword.weWillSend')}}
    </span>
    <div class="field-wrap">
      <label class="form-label">{{$t('auth.yourEmail')}}</label>
      <input type="text"
             v-model="yourEmail"
             :placeholder="$t('becomeManager.form.yourEmail')"
             class="form-control"
             :class="{'form-control--error': v$.yourEmail.$error}"
             maxlength="60"
      />

      <span v-for="(error, index) of v$.yourEmail.$errors" :key="error.$uid" class="form-control-error">
           <template v-if="index === 0">
            {{ $t(error.$message) }}
          </template>
      </span>

      <span v-if="isEmailSent" class="email-sent-notification">
        {{$t('auth.forgotPassword.restorationLinkSend')}}
      </span>
    </div>
    <button type="button"
            class="submit-btn"
            @click="sendEmail()"
            :class="{'disabled': !buttonState}"
    >{{$t('auth.forgotPassword.sendEmail')}}</button>
  </div>
</app-base-view>
</template>

<style lang="scss">
.forgot-password-view {
  padding: 35px 18px;

  &__title {
    margin-bottom: 20px;
    font-size: 21px;
    font-weight: 600;
    color: #4f4f4f;
  }

  &__desc {
    display: block;
    margin-bottom: 30px;
    font-size: 16px;
    font-weight: 600;
    color: #4f4f4f;
  }

  .field-wrap {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 30px;

    .form-label {
      margin-bottom: 5px;
      color: #4f4f4f;
      font-weight: 600;
    }

    .form-control {
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 4px;
      background: #fff;
      border: solid 1px #d1d1d1;
      color: #4f4f4f;
      &::placeholder {
        color: #bbbbbb;
      }
      &:focus {
        border-color: #999999;
        outline-color: #a163cd;
        color: #000000;
      }
      &:focus-visible {
        outline-color: #a163cd;
      }

      &--error {
        border-color: #fe8f18;
      }
    }

    .form-control-error {
      position: absolute;
      bottom: -10px;
      display: block;
      margin-top: 10px;
      font-size: 12px;
      color: #fe8f18;
    }
  }

  .submit-btn {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    background: #a163cd;
    font-size: 14px;
    font-weight: 600;
    border: none;
    color: #fff;

    &.disabled {
      background: #909090;
      cursor: default;
    }
  }

  .email-sent-notification {
    position: absolute;
    bottom: -10px;
    font-size: 12px;
    font-weight: 600;
    color: #4f4f4f;
  }
}
</style>